/* eslint-disable no-undef, react/prop-types, react/no-danger */
import React from "react";
import { builder, BuilderComponent } from "@builder.io/react";
import kebabCase from "kebab-case";
import Link from "../components/Link/Link";
import SEO from "../components/SEO/SEO";
import ContentDetailView from "../components/ContentDetailView/ContentDetailView";

builder.init(process.env.BUILDER_API_KEY);

const Template = ({ pageContext }) => {
  const { tableName, airtableData, builderDesign } = pageContext;

  return (
    <>
      {airtableData && (
        <SEO
          title={airtableData.title}
          description={airtableData.description}
        />
      )}

      <article className="builder-blocks">
        {builderDesign && airtableData && (
          <ContentDetailView
            data={airtableData}
            link={Link}
            name={kebabCase(tableName)}
            content={builderDesign}
          />

          // <BuilderComponent
          //   renderLink={Link}
          //   name={kebabCase(tableName)}
          //   content={builderDesign}
          //   data={airtableData}
          // />
        )}
      </article>
    </>
  );
};

export default Template;
